module.exports = __webpack_public_path__ + "static/flags/LE-6fdcbbfbbd6851ca7e54ded37c179b73.gif";